import React from "react"
import { Button, useTheme } from "@mallardbay/lib-react-components"
import type { ButtonProps } from "@mallardbay/lib-react-components"
import { navigate } from "gatsby-link"

interface Props extends ButtonProps {
    readonly fullwidth?: boolean
}

// TODO move away from this component
export default function PrimaryGradientButton({ fullwidth, ...props }: Props) {
    const theme = useTheme()
    const baseStyle = {
        // TODO The original component had margin. Remove it and account for externally
        marginTop: theme.space[5],
        marginBottom: theme.space[5],
    }
    const style = fullwidth ? { width: "100%", ...baseStyle } : baseStyle
    return <Button {...props} style={style} gradientEnabled />
}

// A simple wrapper to make it easier to use the gradient button
// and register in builder.io
export function GradientLinkButton({
    href,
    ...props
}: ButtonProps & { readonly href: string }) {
    return <Button {...props} gradientEnabled onClick={() => navigate(href)} />
}
